import {
  GRUPOFAMILIAR_ERROR,
  GRUPOFAMILIAR_SUCCESS,
  GRUPOFAMILIAR_LOADING,
  GRUPOFAMILIAR_RESET,
  SEARCH_DNI_FAMILIAR,
  SEARCH_DNI_FAMILIAR_SUCCESS,
  SEARCH_DNI_FAMILIAR_FAIL,
  GET_TIPOS_PARENTESCO,
  GET_TIPOS_PARENTESCO_SUCCESS,
  GET_TIPOS_PARENTESCO_FAIL,
  LIMPIAR_ADD_FAMILIAR,
  ADD_FAMILIAR_POST,
  ADD_FAMILIAR_POST_SUCCESS,
  ADD_FAMILIAR_POST_FAIL,
  VINCULO_PUT,
  VINCULO_PUT_SUCCESS,
  VINCULO_PUT_FAIL,
  LIMPIAR_POST_FAMILIAR,
  LIMPIAR_DELETE_FAMILIAR,
  DELETE_VINCULO_FAMILIAR,
  DELETE_VINCULO_FAMILIAR_SUCCESS,
  DELETE_VINCULO_FAMILIAR_FAIL,
  ADD_FAMILIAR_CON_CLAVE,
  ADD_FAMILIAR_CON_CLAVE_SUCCESS,
  ADD_FAMILIAR_CON_CLAVE_FAIL,
  LIMPIAR_ADD_FAMILIAR_CLAVE,
  EDITAR_DERECHOS,
  EDITAR_DERECHOS_SUCCESS,
  EDITAR_DERECHOS_FAIL,
  RESET_PORTAL_CONTEXT
} from "../ActionTypes";
import grupoFamiliarInitialState from "../initialStates/grupoFamiliarInitialState";

const grupoFamiliar = (state, { payload, type }) => {

  switch (type) {
    case GRUPOFAMILIAR_LOADING:
      return {
        ...state,
        grupoFamiliar: {
          ...state.grupoFamiliar,
          error: false,
          loading: true,
        },
      };
    case GRUPOFAMILIAR_SUCCESS:
      return {
        ...state,
        grupoFamiliar: {
          ...state.grupoFamiliar,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case GRUPOFAMILIAR_ERROR:
      return {
        ...state,
        grupoFamiliar: {
          ...state.grupoFamiliar,
          error: payload,
          loading: false,
        },
      };

    case GRUPOFAMILIAR_RESET:
      return grupoFamiliarInitialState;
    case RESET_PORTAL_CONTEXT:
      return grupoFamiliarInitialState;
    
    case SEARCH_DNI_FAMILIAR: 
      return  {
          ...state,
          grupoFamiliar: {
            ...state.grupoFamiliar,
            familiar:{
              ...state.grupoFamiliar.familiar, 
              error: false,
              loading: true,
              
            }
          },
        };

      case SEARCH_DNI_FAMILIAR_SUCCESS: 
        return  {
          ...state,
          grupoFamiliar: {
            ...state.grupoFamiliar,
            familiar:{
              ...state.grupoFamiliar.familiar, 
              loading: false,
              error: false,
              data: payload
            }
          },
        };
      
      case SEARCH_DNI_FAMILIAR_FAIL: 
        return  {
          ...state,
          grupoFamiliar: {
            ...state.grupoFamiliar,
            familiar:{
              ...state.grupoFamiliar.familiar, 
              loading: false,
              error: payload,
              data: payload
            }
          },
        };
      
        case  GET_TIPOS_PARENTESCO: 
          return {
            ...state,
            grupoFamiliar: {
              ...state.grupoFamiliar,
              tiposParentesco: {
                ...state.grupoFamiliar.tiposParentesco,
                loading: true,
                error: false,
                data: [],
              }
            }
          }
          case  GET_TIPOS_PARENTESCO_SUCCESS: 
          return {
            ...state,
            grupoFamiliar: {
              ...state.grupoFamiliar,
              tiposParentesco: {
                ...state.grupoFamiliar.tiposParentesco,
                loading: false,
                error: false,
                data: payload.data,
              }
            }
          }
          case  GET_TIPOS_PARENTESCO_FAIL: 
            return {
              ...state,
              grupoFamiliar: {
                ...state.grupoFamiliar,
                tiposParentesco: {
                  ...state.grupoFamiliar.tiposParentesco,
                  loading: false,
                  error: payload.data,
                  data: [],
                }
              }
            }
          case  LIMPIAR_ADD_FAMILIAR: 
            return {
              ...state,
              grupoFamiliar: {
                ...state.grupoFamiliar,
                familiar: {
                  loading: false,
                  error: false,
                  data: []
                }
              }
            }
        case ADD_FAMILIAR_POST: 
          return {
            ...state,
            grupoFamiliar: {
              ...state.grupoFamiliar,
              loading: true,
              postFamiliar: {
                loading: true,
                error: false,
                data: false
              }
            }
          }
        case ADD_FAMILIAR_POST_SUCCESS: 
          return {
            ...state,
            grupoFamiliar: {
              ...state.grupoFamiliar,
              loading: false,
              postFamiliar: {
                loading: false,
                error: false,
                data: payload.data
              }
            }
          }
        case ADD_FAMILIAR_POST_FAIL: 
          return {
            ...state,
            grupoFamiliar: {
              ...state.grupoFamiliar,
              loading: false, 
              postFamiliar: {
                loading: false,
                error: true,
                data: false
              }
            }
          }
        case VINCULO_PUT: 
          return {
            ...state,
            grupoFamiliar: {
              ...state.grupoFamiliar,
              loading: true, 
              putFamiliar: {
                loading: true,
                error: false,
                data:false,
              }
            }
          }
        case VINCULO_PUT_SUCCESS: 
          return {
            ...state,
            grupoFamiliar: {
              ...state.grupoFamiliar,
              loading: false,
              putFamiliar: {
                loading: false,
                error: false,
                data: payload.data,
              }
            }
          }
        case VINCULO_PUT_FAIL: 
          return {
            ...state,
            grupoFamiliar: {
              ...state.grupoFamiliar,
              loading: false,
              putFamiliar: {
                loading: false,
                error: payload.data,
                data: false,
              }
            }
          }
        case LIMPIAR_POST_FAMILIAR: 
         return {
          ...state,
          grupoFamiliar: {
            ...state.grupoFamiliar,
            postFamiliar: {
              loading: false,
              error: false,
              data: false,
            }
          }
        }
       case LIMPIAR_DELETE_FAMILIAR: 
        return {
          ...state, 
          grupoFamiliar: {
            ...state.grupoFamiliar,
            deleteFamiliar: {
              loading: false,
              error: false, 
              data: true 
            }
          }
        }
      case DELETE_VINCULO_FAMILIAR:
        return {
          ...state, 
          grupoFamiliar: {
            ...state.grupoFamiliar,
            loading: true, 
            deleteFamiliar: {
              loading: true,
              error: false, 
              data: false
           
            }
          }
        }
       case DELETE_VINCULO_FAMILIAR_SUCCESS:
        return {
          ...state, 
          grupoFamiliar: {
            ...state.grupoFamiliar,
            loading: false, 
            deleteFamiliar: {
              loading: false,
              error: false, 
              data: !state.grupoFamiliar.deleteFamiliar  
            }
          }
        }
        case DELETE_VINCULO_FAMILIAR_FAIL:
          return {
            ...state, 
            grupoFamiliar: {
              ...state.grupoFamiliar,
              loading: false, 
              deleteFamiliar: {
                loading: false,
                error: true, 
                data: false
              }
            }
          }
       case ADD_FAMILIAR_CON_CLAVE: 
         return {
            ...state, 
            grupoFamiliar: {
              ...state.grupoFamiliar,
              postFamiliarClave: {
                loading: true,
                error: false, 
                data: false
              }
            }
          } 
        case ADD_FAMILIAR_CON_CLAVE_SUCCESS: 
         return {
            ...state, 
            grupoFamiliar: {
              ...state.grupoFamiliar,
              postFamiliarClave: {
                loading: false,
                error: false, 
                data: true
              }
            }
          } 
        case ADD_FAMILIAR_CON_CLAVE_FAIL: 
         return {
            ...state, 
            grupoFamiliar: {
              ...state.grupoFamiliar,
              postFamiliarClave: {
                loading: false,
                error: true, 
                data: false 
              }
            }
          } 
        case LIMPIAR_ADD_FAMILIAR_CLAVE: 
          return {
            ...state, 
            grupoFamiliar: {
              ...state.grupoFamiliar,
              postFamiliarClave: {
                loading: false,
                error: false, 
                data: false 
              }
            }
          } 
        case EDITAR_DERECHOS: 
         return {
           ...state, 
           grupoFamiliar: {
             ...state.grupoFamiliar,
             loading: true,  
             editarDerechos: {
               loading: true,
               error: false,
             }
           }
         }
        case EDITAR_DERECHOS_SUCCESS: 
         return {
           ...state, 
           grupoFamiliar: {
             ...state.grupoFamiliar,
             loading: false, 
             editarDerechos: {
               loading: false,
               error: false, 
               data: payload.data
             }
           }
         }
        case EDITAR_DERECHOS_FAIL: 
         return {
           ...state, 
           grupoFamiliar: {
             ...state.grupoFamiliar,
             loading: false, 
             editarDerechos: {
               loading: false,
               error: true, 
               data: false
             }
           }
         }
    default:
      return state;
  }
};

export default grupoFamiliar;

// familiar